<template>
  <div class="container" :class="classes">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Container',
  props: {
    align: String
  },
  computed: {
    classes () {
      return {
        [`align-${this.align}`]: this.align
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../scss/boilerplate';

.container {
  @include make-container();
  width: 100%;
  max-width: none;
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.align {
  &-center {
    display: flex;
    align-items: center;
  }
}
</style>


// WEBPACK FOOTER //
// Container.vue?8cf3b8c2